import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithDrive_1 from '../../../../../libraries/Images/createAConnectionWithDrive_1.png';
import createAConnectionWithDrive_2 from '../../../../../libraries/Images/createAConnectionWithDrive_2.png';
import createAConnectionWithDrive_3 from '../../../../../libraries/Images/createAConnectionWithDrive_3.png';
import createAConnectionWithDrive_4 from '../../../../../libraries/Images/createAConnectionWithDrive_4.png';
import createAConnectionWithDrive_5 from '../../../../../libraries/Images/createAConnectionWithDrive_5.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithdrive">
                1.&nbsp;{translate('createaconnectionwithdrive')}
            </Typography>
            <p>Click "Add New" to create the connection.</p>
            <Zoom>
                <img src={createAConnectionWithDrive_1} width="75%" />
            </Zoom>
            <p>A list of applications that can be linked will appear, select "Drive" among them.</p>
            <Zoom>
                <img src={createAConnectionWithDrive_2} width="75%" />
            </Zoom>
            <p>When you click "Drive", the user's Google account selection screen is displayed. Please select an account to use for the connection.</p>
            <Zoom>
                <img src={createAConnectionWithDrive_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>When you select an account, "RPA CLOUD" will request access on your behalf. Agree to grant the above access permission to "RPA CLOUD" and click "Allow".</p>
            <Zoom>
                <img src={createAConnectionWithDrive_4} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>You will see a Drive card once the connection is successfully created.</p>
            <Zoom>
                <img src={createAConnectionWithDrive_5} width="50%"/>
            </Zoom>
            <p>Use the <strong>Provider ID</strong> included in this tag to perform the steps in Drive.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(En);